"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var text_editor_1 = require("../text-editor");
var repeater_row_1 = require("./repeater-row");
var EpsilonRepeaterUtils = /** @class */ (function () {
    /**
     * Constructor
     * @param {EpsilonFieldRepeater | EpsilonSectionRepeater} control
     */
    function EpsilonRepeaterUtils(control) {
        this.control = control;
    }
    /**
     * Deletes a row
     */
    EpsilonRepeaterUtils.prototype.delete = function (row, index) {
        var self = this;
        var settings = this.getValue(), currentRow, i, prop;
        if (settings[index]) {
            // Find the row
            row = this.control.rows[index];
            if (row) {
                // Remove the row settings
                delete settings[index];
                // Remove the row from the rows collection
                delete this.control.rows[index];
            }
        }
        settings = this.cleanArray(settings);
        this.control.rows = self.cleanArray(this.control.rows);
        jQuery.each(this.control.rows, function (index, element) {
            self.setIndex(element, index);
        });
        // Update the new setting values
        this.setValue(settings);
        // Remap the row numbers
        i = 1;
        for (prop in this.control.rows) {
            if (this.control.rows.hasOwnProperty(prop) && this.control.rows[prop]) {
                self.updateLabel(this.control.rows[prop]);
                i++;
            }
        }
    };
    /**
     * Adds a row
     */
    EpsilonRepeaterUtils.prototype.add = function (data) {
        var self = this;
        var template = _.memoize(this.control.template), newSetting = {}, templateData, value = this.getValue(), i, rowContainer, row;
        /**
         * In case we don`t have a template, we terminate here
         */
        if (!template) {
            return false;
        }
        /**
         * Extend template data with what we passed in PHP
         */
        templateData = jQuery.extend(true, {}, this.control.control.params.fields);
        /**
         * In case we added the row with "known" data, we need to overwrite the array
         */
        if (data) {
            for (i in data) {
                if (data.hasOwnProperty(i) && templateData.hasOwnProperty(i)) {
                    templateData[i]['default'] = data[i];
                }
            }
        }
        /**
         * Add an index
         *
         * @type {number}
         */
        templateData['index'] = this.control.currentIndex;
        /**
         * Render the HTML template with underscores
         */
        template = template(templateData);
        rowContainer = jQuery(template).appendTo(this.control.repeaterContainer);
        row = new repeater_row_1.EpsilonRepeaterRow(this.control, rowContainer);
        /**
         * Bind events to the new row
         */
        this.handleRowEvents(row);
        /**
         * Register the new row in the control
         *
         * @type {*}
         */
        this.control.rows[this.control.currentIndex] = row;
        /**
         * Add a new "index" to the setting ( easier to render in the frontend )
         */
        for (i in templateData) {
            if (templateData.hasOwnProperty(i)) {
                newSetting[i] = templateData[i]['default'];
            }
        }
        if ('undefined' === typeof newSetting['index']) {
            newSetting['index'] = this.control.currentIndex;
        }
        /**
         * Add a value to the setting
         * @type {{}}
         */
        value[this.control.currentIndex] = newSetting;
        /**
         * Set it
         */
        if (!data) {
            this.setValue(value);
        }
        this.control.handleRowIncrementor();
        return row;
    };
    /**
     * Sort fields
     */
    EpsilonRepeaterUtils.prototype.sort = function (data) {
        var self = this;
        var rows = this.control.repeaterContainer.find('.repeater-row'), settings = this.getValue(), newOrder = [], newRows = [], newSettings = [], textEditorSettings;
        rows.each(function (i, el) {
            newOrder.push(jQuery(el).data('row'));
        });
        jQuery.each(newOrder, function (newPosition, oldPosition) {
            newRows[newPosition] = self.control.rows[oldPosition];
            self.setIndex(newRows[newPosition], newPosition);
            newSettings[newPosition] = settings[oldPosition];
        });
        var textareas = rows.find('textarea');
        var _loop_1 = function (i) {
            setTimeout(function () {
                var settings = {
                    container: jQuery(textareas[i]).parent(),
                    params: {
                        id: jQuery(textareas[i]).attr('id')
                    }
                };
                new text_editor_1.EpsilonTextEditor(settings, true, true);
            }, 100 * i);
        };
        for (var i = 0; i < textareas.length; i++) {
            _loop_1(i);
        }
        this.control.rows = newRows;
        this.setValue(newSettings);
        if (self.control.control.params['selective_refresh']) {
            wp.customize.previewer.refresh();
        }
    };
    /**
     * Saves value
     */
    EpsilonRepeaterUtils.prototype.setValue = function (value) {
        this.control.control.setting.set([]);
        this.control.control.setting.set(value);
    };
    /**
     * Gets the setting value
     */
    EpsilonRepeaterUtils.prototype.getValue = function () {
        return this.control.control.setting.get();
    };
    /**
     * Update a single field inside a row.
     * Triggered when a field has changed
     */
    EpsilonRepeaterUtils.prototype.updateField = function (instance, fieldId, element) {
        var row = this.control.rows[instance.index], value = this.control.utils.getValue();
        this.updateRepeater(instance, fieldId, element);
    };
    /**
     * Updates a field repeater
     *
     * @param instance
     * @param {string} fieldId
     * @param {JQuery} element
     * @public
     */
    EpsilonRepeaterUtils.prototype.updateRepeater = function (instance, fieldId, element) {
        var row = this.control.rows[instance.index], value = this.control.utils.getValue();
        if (!row) {
            return;
        }
        if (!this.control.control.params.fields[fieldId]) {
            return;
        }
        if (_.isUndefined(value[row.index][fieldId])) {
            return;
        }
        switch (this.control.control.params.fields[fieldId].type) {
            case 'checkbox':
            case 'epsilon-toggle':
                value[row.index][fieldId] = jQuery(element).prop('checked');
                break;
            default:
                value[row.index][fieldId] = jQuery(element).val();
                break;
        }
        this.control.utils.setValue(value);
    };
    /**
     * Load underscores template
     */
    EpsilonRepeaterUtils.prototype.repeaterTemplate = function () {
        var compiled, options = {
            evaluate: /<#([\s\S]+?)#>/g,
            interpolate: /\{\{\{([\s\S]+?)\}\}\}/g,
            escape: /\{\{([^\}]+?)\}\}(?!\})/g,
            variable: 'data'
        };
        return function (data) {
            compiled = _.template(jQuery('.customize-control-epsilon-repeater-content-field').html(), null, options);
            return compiled(data);
        };
    };
    /**
     * Set the row's index
     */
    EpsilonRepeaterUtils.prototype.setIndex = function (row, index) {
        row.index = index;
        row.container.attr('data-row', index);
        row.container.data('row', index);
        this.control.utils.updateLabel(row);
    };
    /**
     * Removes a row from the container
     */
    EpsilonRepeaterUtils.prototype.removeRow = function (row) {
        row.container.slideUp(300, function () {
            jQuery(this).detach();
        });
        row.container.trigger('row:remove', [row.index]);
    };
    /**
     * Update row label
     */
    EpsilonRepeaterUtils.prototype.updateLabel = function (row) {
        var rowLabelField, rowLabel, rowLabelSelector;
        if ('field' === row.label.type) {
            rowLabelField = row.container.find('.repeater-field [data-field="' + row.label.field + '"]');
            if (_.isFunction(rowLabelField.val)) {
                rowLabel = rowLabelField.val();
                if ('' !== rowLabel) {
                    if (!_.isUndefined(this.control.control.params.fields[row.label.field])) {
                        if (!_.isUndefined(this.control.control.params.fields[row.label.field].type)) {
                            if ('select' === this.control.control.params.fields[row.label.field].type) {
                                if (!_.isUndefined(this.control.control.params.fields[row.label.field].choices) &&
                                    !_.isUndefined(this.control.control.params.fields[row.label.field].choices[rowLabel])) {
                                    rowLabel = this.control.control.params.fields[row.label.field].choices[rowLabel];
                                }
                            }
                            else if ('radio' === this.control.control.params.fields[row.label.field].type || 'radio-image' === this.control.control.params.fields[row.label.field].type) {
                                rowLabelSelector = this.control.control.selector + ' [data-row="' + row.index + '"] .repeater-field [data-field="' + row.label.field + '"]:checked';
                                rowLabel = jQuery(rowLabelSelector).val();
                            }
                        }
                    }
                    row.header.find('.repeater-row-label').text(rowLabel);
                    return;
                }
            }
        }
        row.header.find('.repeater-row-label').text(row.label.value + ' ' + (row.index + 1));
    };
    /**
     * Toggles the row vizibility
     */
    EpsilonRepeaterUtils.prototype.toggleMinimize = function (row, section) {
        if (section === void 0) { section = false; }
        var self = this;
        if (row.hasOwnProperty('type')) {
            section = true;
        }
        row.container.find('.repeater-row-content').slideToggle(300, function () {
            row.container.toggleClass('minimized');
            row.header.find('.dashicons').toggleClass('dashicons-arrow-up').toggleClass('dashicons-arrow-down');
            /**
             * In case we are in a section, we need to close others
             */
            if (section) {
                jQuery('body').removeClass('adding-section');
                jQuery('body').removeClass('adding-doubled-section');
                jQuery('#sections-left-' + self.control.control.params.id).find('.available-sections').removeClass('opened');
                wp.customize.previewer.send('epsilon-section-focused', { index: row.index, closed: row.container.hasClass('minimized') });
                jQuery.each(row.container.siblings(), function (index, element) {
                    if (!jQuery(element).hasClass('minimized')) {
                        jQuery(element).addClass('minimized');
                        jQuery(element).find('.repeater-row-content').slideToggle(300, function () {
                            jQuery(element).
                                find('repeater-row-header').
                                addClass('minimized').
                                find('.dashicons').
                                toggleClass('dashicons-arrow-up').
                                toggleClass('dashicons-arrow-down');
                        });
                    }
                });
            }
        });
    };
    /**
     * Cleans an arrow of undefined values
     */
    EpsilonRepeaterUtils.prototype.cleanArray = function (obj) {
        var arr = [];
        for (var i = 0; i < obj.length; i++) {
            if (obj[i]) {
                arr.push(obj[i]);
            }
        }
        return arr;
    };
    /**
     * Handle row events
     */
    EpsilonRepeaterUtils.prototype.handleRowEvents = function (row) {
        var self = this;
        /**
         * 1. Remove row event
         */
        row.container.on('row:remove', function (e, index) {
            self.delete(row, index);
            if ('epsilon-section-repeater' === self.control.control.params.type) {
                jQuery('body').removeClass('adding-doubled-section');
            }
            if (self.control.control.params['selective_refresh']) {
                wp.customize.previewer.refresh();
            }
        });
        /**
         * 2. Initiate sortable script
         */
        row.header.on('mousedown', function () {
            row.container.trigger('row:start-dragging');
        });
    };
    return EpsilonRepeaterUtils;
}());
exports.EpsilonRepeaterUtils = EpsilonRepeaterUtils;



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/controls/repeater/repeater-utils.ts
// module id = 9
// module chunks = 0